document.addEventListener("DOMContentLoaded", function () {
  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function eqCI(a, b) {
    return normalize(a) === normalize(b);
  }

  function isColorOption(name) {
    const n = normalize(name);
    return n.includes("color") || n.includes("colour") || n.includes("couleur") || n.includes("colores") || n.includes("farbe") || n.includes("カラー") || n.includes("色");
  }

  /* =================
     GALLERY SWAP
  ================= */
  const thumbnails = Array.from(document.querySelectorAll(".thumbnail"));
  const mainBanner = document.getElementById("main-banner");

  function swapMainSrc(newSrc) {
    if (!mainBanner || !newSrc) return;

    mainBanner.classList.add("fade-in");

    const img = new Image();
    img.onload = () => {
      mainBanner.src = newSrc;
      mainBanner.srcset = newSrc;
      requestAnimationFrame(() => mainBanner.classList.remove("fade-in"));
    };
    img.onerror = () => mainBanner.classList.remove("fade-in");
    img.src = newSrc;
  }

  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", function () {
      thumbnails.forEach((t) => t.classList.remove("selected"));
      this.classList.add("selected");
      swapMainSrc(this.dataset.large || this.src);
    });
  });

  /* =================
     MOBILE SWIPE
  ================= */
  (function () {
    if (!mainBanner || !thumbnails.length) return;

    let currentIndex = thumbnails.findIndex((el) => el.classList.contains("selected"));
    if (currentIndex < 0) currentIndex = 0;

    let startX = 0;
    let startY = 0;
    let swiping = false;

    function goTo(idx) {
      currentIndex = (idx + thumbnails.length) % thumbnails.length;
      thumbnails.forEach((x) => x.classList.remove("selected"));
      const t = thumbnails[currentIndex];
      t.classList.add("selected");
      swapMainSrc(t.dataset.large || t.src);
    }

    mainBanner.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });

    mainBanner.addEventListener("touchend", (e) => {
      if (!swiping) return;
      swiping = false;

      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;

      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      }
    });
  })();

  /* =================
     PRODUCT FORM
  ================= */
  const form = document.querySelector("form[id^='product-form-']");
  if (!form) return;

  const hiddenInput = form.querySelector("input[name='id']");
  const addToCartBtn = document.querySelector("button[id^='add-to-cart-']");
  const addToCartWrap = addToCartBtn?.closest(".add-to-cart-wrapper");
  const hintEl = document.querySelector("p[id^='selection-hint-']");
  const optionButtons = Array.from(form.querySelectorAll(".option-btn[data-option-group='color']"));
  const preview = document.getElementById("color-preview");
  const priceEls = document.querySelectorAll(".sticky-cart-price");

  if (hintEl) {
    hintEl.dataset.defaultText = hintEl.textContent.trim();
  }

  if (hintEl && addToCartWrap && hintEl.parentElement !== addToCartWrap) {
    addToCartWrap.prepend(hintEl);
  }

  const variants = Array.isArray(window.productVariants) ? window.productVariants : [];
  const optionNames = Array.isArray(window.productOptionNames) ? window.productOptionNames : [];
  const initialPriceHTML = priceEls[0] ? priceEls[0].innerHTML : "";

  const detectedColorIndex = optionNames.findIndex(isColorOption);
  const colorOptionIndex = detectedColorIndex >= 0 ? detectedColorIndex : 0;

  function setPriceHTML(variant) {
    if (!variant) {
      priceEls.forEach((el) => {
        el.innerHTML = initialPriceHTML;
      });
      return;
    }

    priceEls.forEach((el) => {
      if (
        variant.formatted_compare_at_price &&
        Number(variant.compare_at_price) > Number(variant.price)
      ) {
        el.innerHTML = `
          <span class="price--compare"><s>${variant.formatted_compare_at_price}</s></span>
          <span class="price--sale">${variant.formatted_price}</span>
        `;
      } else {
        el.innerHTML = variant.formatted_price || initialPriceHTML;
      }
    });
  }

  function setCartVisibility(showButton, hintText = "", hintState = "") {
    if (addToCartBtn) {
      addToCartBtn.style.visibility = showButton ? "visible" : "hidden";
      addToCartBtn.style.pointerEvents = showButton ? "auto" : "none";
    }

    if (hintEl) {
      hintEl.style.display = showButton ? "none" : "block";
      hintEl.textContent = hintText || hintEl.dataset.defaultText || "";
      hintEl.classList.remove("ready", "warning");

      if (hintState) {
        hintEl.classList.add(hintState);
      }
    }
  }

  function getSelectedButton() {
    return form.querySelector(".option-btn[data-option-group='color'].active");
  }

  function getSelectedValue() {
    return getSelectedButton()?.dataset.value || "";
  }

  function getVariantByColor(value) {
    return variants.find((variant) => eqCI(variant.options?.[colorOptionIndex], value));
  }

  function getAvailableVariantByColor(value) {
    return variants.find((variant) => {
      return eqCI(variant.options?.[colorOptionIndex], value) && variant.available;
    });
  }

  function renderPreview(value) {
    if (!preview) return;

    if (!value) {
      preview.innerHTML = "";
      return;
    }

    const variant = getVariantByColor(value);

    if (variant?.featured_image) {
      preview.innerHTML = `
        <img
          src="${variant.featured_image}"
          width="280"
          height="280"
          loading="lazy"
          alt="${value}"
        >
      `;
    } else {
      preview.innerHTML = "";
    }
  }

  function updateButtonAvailability() {
    optionButtons.forEach((btn) => {
      const value = btn.dataset.value || "";
      const availableVariant = getAvailableVariantByColor(value);
      const isUnavailable = !availableVariant;

      btn.disabled = isUnavailable;
      btn.classList.toggle("unavailable", isUnavailable);
      btn.classList.toggle("is-disabled", isUnavailable);
      btn.setAttribute("aria-disabled", String(isUnavailable));

      if (isUnavailable && btn.classList.contains("active")) {
        btn.classList.remove("active");
        btn.setAttribute("aria-pressed", "false");
      }
    });
  }

  function updateState() {
    const selectedValue = getSelectedValue();

    if (!selectedValue) {
      hiddenInput.value = "";
      addToCartBtn.disabled = true;
      renderPreview("");
      setPriceHTML(null);
      setCartVisibility(false, hintEl?.dataset.defaultText || window.themeStrings?.selection_required || "");
      return;
    }

    const variant = getVariantByColor(selectedValue);

    renderPreview(selectedValue);

    if (variant && variant.available) {
      hiddenInput.value = variant.id;
      addToCartBtn.disabled = false;
      setPriceHTML(variant);
      setCartVisibility(true);
    } else {
      hiddenInput.value = "";
      addToCartBtn.disabled = true;
      setPriceHTML(variant || null);
      setCartVisibility(
        false,
        window.themeStrings?.unavailable || hintEl?.dataset.defaultText || "",
        "warning"
      );
    }
  }

  optionButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.disabled) return;

      optionButtons.forEach((b) => {
        b.classList.remove("active");
        b.setAttribute("aria-pressed", "false");
      });

      btn.classList.add("active");
      btn.setAttribute("aria-pressed", "true");

      updateState();
    });
  });

  updateButtonAvailability();
  updateState();

  /* =================
     SHIPPING ACCORDION
  ================= */
  const toggle = document.querySelector(".shipping-toggle");
  const content = document.getElementById("shipping-content");

  if (toggle && content) {
    toggle.addEventListener("click", () => {
      const open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      content.classList.toggle("open", !open);
    });
  }

  function loadDeferredInfoMedia(panel) {
    if (!panel) return;

    panel.querySelectorAll("iframe[data-src]").forEach((frame) => {
      if (frame.hasAttribute("src")) return;

      const source = frame.dataset.src;
      if (!source) return;

      frame.src = source;
      frame.removeAttribute("data-src");
    });

    panel.querySelectorAll("video[data-src]").forEach((video) => {
      if (video.hasAttribute("src")) return;

      const source = video.dataset.src;
      if (!source) return;

      video.src = source;
      video.removeAttribute("data-src");
      video.load();
    });
  }

  /* =================
     MORE INFO BUTTONS
  ================= */
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".variant-more-info-btn");
    if (!btn) return;

    const key = btn.dataset.info;
    const target = document.querySelector(`.variant-more-info-content[data-info-target="${key}"]`);
    if (!target) return;

    const isOpen = target.classList.contains("open");

    document
      .querySelectorAll(".variant-more-info-content")
      .forEach((section) => section.classList.remove("open"));

    document
      .querySelectorAll(".variant-more-info-btn")
      .forEach((button) => {
        if (window.themeStrings?.more_info) {
          button.textContent = window.themeStrings.more_info;
        }
        button.setAttribute("aria-expanded", "false");
      });

    if (!isOpen) {
      target.classList.add("open");
      loadDeferredInfoMedia(target);

      if (window.themeStrings?.hide_info) {
        btn.textContent = window.themeStrings.hide_info;
      }
      btn.setAttribute("aria-expanded", "true");
    }
  });
});